import { configureStore } from '@reduxjs/toolkit';
import ui from './slices/ui';
import workspaces from './slices/workspaces';
import language from './slices/language';
import currentWorkspace from './slices/currentWorkspace';
import user from './slices/user';
import users from './slices/users';
import monitoring from './slices/monitoring';
import devices from './slices/devices';
import customers from './slices/customers';
import events from './slices/events';
import invitations from './slices/invitations';
import roles from './slices/roles';
import brands from './slices/brands';
import models from './slices/models';
import eventGroups from './slices/eventGroups';
import emergencyContacts from './slices/emergencyContacts';
import emergencyContactLists from './slices/emergencyContactList';
import deviceHistories from './slices/deviceHistories';
import situations from './slices/situations';
import resolutions from './slices/resolutions';
import places from './slices/places';
import chat from './slices/chat';
import kanban from './slices/kanban';

const store = configureStore({
  reducer: {
    ui,
    language,
    workspaces,
    currentWorkspace,
    user,
    users,
    devices,
    customers,
    events,
    invitations,
    roles,
    monitoring,
    situations,
    deviceHistories,
    resolutions,
    brands,
    models,
    eventGroups,
    emergencyContacts,
    emergencyContactLists,
    places,
    chat,
    kanban,
  },
});

export default store;
